<template>
  <div class="page">
    <div class="black">
      <img src="https://qiniu.huayueshengwu.com/icon-OK.png" />
      <p class="title">恭喜注册成功!</p>
      <p>赶快下载 APP</p>
      <p>免费获取AI作画次数</p>
    </div>
    <div class="footer" v-if="iswx">
      <!-- <div v-if="isios" class="btn" @click="downLoad">IOS下载</div> -->
      <div class="btn" @click="downLoad">Android 下载</div>
    </div>
    <div class="footer" v-else>
      <!-- <div v-if="isios" class="btn">
        <a
          href="https://apps.apple.com/cn/app/%E8%8F%8C%E8%90%BD%E6%A3%AE%E6%9E%97/id1596458623"
          >IOS下载</a
        >
      </div> -->
      <div class="btn">
        <a href="https://qiniu.huashuyun.net/app/ai-master.apk">Android 下载</a>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Home',
  data() {
    return {
      open: false,
      isios: true,
      recUserId: 0,
      iswx: false,
    };
  },
  created() {
    this.appSource();
    this.isWeiXin();
    // this.recUserId = sessionStorage.getItem("recUserId");
    // let ad_member_token = sessionStorage.getItem("ad_member_token");
    // if (!ad_member_token) {
    //   this.$router.replace({
    //     path: "/Login?rec_user_id=" + this.recUserId,
    //   });
    // }
    // console.log(this.recUserId, "this.recUserId");
  },
  methods: {
    appSource() {
      const u = navigator.userAgent;
      this.isios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      console.log(this.isios, 'isios');
    },
    downLoad() {
      this.$toast('请在浏览器中打开！');
    },
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        this.iswx = true;
      } else {
        this.iswx = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page {
  position: relative;
  background: url('https://qiniu.huayueshengwu.com/pic-xzymbjt%402x.png')
    #0d0c0b;
  height: 100vh;
  background-size: 100% auto;

  .black {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 362px 30px 62px;
    img {
      display: block;
      width: 87px;
      height: 87px;
    }

    p {
      display: block;
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #fff;
      line-height: 24px;
    }
    .title {
      font-size: 24px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: bold;
      text-align: center;
      color: #fff;
      line-height: 40px;
      margin: 13px 0 5px;
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0px;
    width: 100%;
    padding: 26px 21px;
    box-sizing: border-box;

    .btn {
      width: 100%;
      height: 45px;
      line-height: 45px;
      margin: 0px auto;
      color: #fff;
      text-align: center;
      background: linear-gradient(90deg, #f27105, #1dc98e);
      border-radius: 30px;
      a {
        color: #fff;
      }
    }

    .iosbtn {
      background: linear-gradient(90deg, #f27105, #1dc98e);
      margin-bottom: 20px;
    }
  }
}
</style>
